// src/pages/productions/formula/Calculation.js

/**
 * Fungsi untuk menghitung Berat Box (KG)
 * Formula: Berat Box (KG) = Sum of Qty * Berat Kemasan (KG)
 * @param {number|string} sumOfQty - Sum of Qty
 * @param {number|string} beratKemasan - Berat Kemasan (KG)
 * @returns {string} Hasil perhitungan dalam format 4 desimal
 */
export const calculateBeratBox = (sumOfQty, beratKemasan) => {
    try {
        // Konversi ke number
        const qty = typeof sumOfQty === 'string' ? parseFloat(sumOfQty) : Number(sumOfQty);
        const berat = typeof beratKemasan === 'string' ? parseFloat(beratKemasan) : Number(beratKemasan);
        
        // Validasi input
        if (isNaN(qty) || isNaN(berat)) {
            return '0.0000';
        }
        
        // Hitung Berat Box
        const beratBox = qty * berat;
        
        // Format ke 3 digit desimal
        return beratBox.toFixed(3);
    } catch (error) {
        console.error('Error in calculateBeratBox:', error);
        return '0.0000';
    }
};

/**
 * Fungsi untuk menghitung Netto (KG)
 * Formula: Netto (KG) = Sum of Weight (KG) - Berat Box (KG)
 * @param {number|string} sumOfWeight - Sum of Weight (KG)
 * @param {number|string} beratBox - Berat Box (KG) hasil dari calculateBeratBox
 * @returns {string} Hasil perhitungan dalam format 4 desimal
 */
export const calculateNetto = (sumOfWeight, beratBox) => {
    try {
        // Konversi ke number
        const weight = typeof sumOfWeight === 'string' ? parseFloat(sumOfWeight) : Number(sumOfWeight);
        const boxWeight = typeof beratBox === 'string' ? parseFloat(beratBox) : Number(beratBox);
        
        // Validasi input
        if (isNaN(weight) || isNaN(boxWeight)) {
            return '0.0000';
        }
        
        // Hitung Netto
        const netto = weight - boxWeight;
        
        // Pastikan netto tidak negatif
        const finalNetto = netto < 0 ? 0 : netto;
        
        // Format ke 3 digit desimal
        return finalNetto.toFixed(3);
    } catch (error) {
        console.error('Error in calculateNetto:', error);
        return '0.0000';
    }
};

/**
 * Fungsi untuk menghitung semua nilai terkait berat
 * @param {object} data - Data produksi
 * @returns {object} Data dengan perhitungan berat box dan netto
 */
export const calculateWeightValues = (data) => {
    try {
        const { sum_of_qty, sum_of_weight, berat_kemasan } = data;
        
        // Hitung Berat Box
        const berat_box = calculateBeratBox(sum_of_qty, berat_kemasan);
        
        // Hitung Netto
        const netto = calculateNetto(sum_of_weight, berat_box);
        
        return {
            ...data,
            berat_box,
            netto
        };
    } catch (error) {
        console.error('Error in calculateWeightValues:', error);
        return {
            ...data,
            berat_box: '0.0000',
            netto: '0.0000'
        };
    }
};